<template>
  <v-row class="pb-3">
    <v-col cols="12">
      <input-radio
        v-model="getStatus"
        :options="options"
        :rules="[requiredRule]"
        row
        required
      />
    </v-col>
    <v-col
      v-if="isPending"
      cols="12"
    >
      <v-row>
        <v-col cols="6">
          <input-date
            id="input:date"
            v-model="payload.date"
            label="Data de envio"
            :rules="[requiredRule]"
            required
            outlined
          />
        </v-col>
        <v-col cols="6">
          <input-text
            id="input:hours"
            v-model="payload.hours"
            v-mask="'##:##'"
            label="Horário do envio"
            placeholder="12:00"
            :rules="[requiredRule]"
            required
            outlined
          />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import RulesMixin from '@/app/arch/mixins/RulesMixin';

export default {
  name: 'NotificationStatusContent',
  mixins: [RulesMixin],
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    options: [
      {
        label: 'Agendar envio',
        value: 'Pending',
        color: 'warning',
      },
      {
        label: 'Salvar rascunho',
        value: 'Draft',
        color: 'neutral',
      },
      {
        label: 'Enviar notificações',
        value: 'Sent',
        color: 'success',
      },
    ],
    payload: {
      date: '',
      hours: '',
    },
  }),
  computed: {
    getStatus: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    handleDraftStatus() {
      return () => this.handelMessagesDraft(
        this.getStatus === 'Draft',
      );
    },
    isPending() {
      return this.getStatus === 'Pending';
    },
    getDate() {
      return `${this.payload.date}T${this.payload.hours}:00.000Z`;
    },
    setScheduleDate() {
      return this.handleScheduleDate;
    },
  },
  watch: {
    getStatus: {
      immediate: true,
      handler(status) {
        if (status !== '') {
          this.handleDraftStatus();
        }
      },
    },
    getDate: {
      immediate: true,
      handler() {
        this.setScheduleDate(
          this.getDate,
        );
      },
    },
  },
  inject: {
    handelMessagesDraft: {
      default() {
        return (v) => v;
      },
    },
    handleScheduleDate: {
      default() {
        return (v) => v;
      },
    },
  },
};
</script>
